import haversine from 'haversine-distance'

export class Coordinate {
    lat: number
    lng: number
    siduri: number | null

    constructor(lat: number, lng: number, siduri: number | null) {
        this.lat = lat
        this.lng = lng
        this.siduri = siduri
    }

    distanceFrom(other: Coordinate) {
        return haversine(this, other)
    }
}